import { useQuery } from 'react-query';
import MilkFixedService from '~/api/services/milkFixedPrice';
import { onError } from '~/utils/helpers';

const getMilkFixexPriceList = (data?) => useQuery(
  `milk-fixed-price-list-${data.search}`,
  () => MilkFixedService.getMilkFixedPriceIndex(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceListOptions = () => useQuery(
  'milk-fixed-price-list-options',
  MilkFixedService.getMilkFixedPriceIndexData,
  {
    onError,
    refetchOnMount: true,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOptions = () => useQuery(
  'milk-fixed-price-options',
  MilkFixedService.getMilkFixedPriceOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceCount = (data?) => useQuery(
  `milk-fixed-price-count-${data.search}`,
  () => MilkFixedService.countTradingSlots(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffers = (id, data?) => useQuery(
  'milk-fixed-price-offers',
  () => MilkFixedService.offersPreviewTradingSlot(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersByOptions = (id, farmerId?) => useQuery(
  'milk-fixed-price-offers-list',
  () => MilkFixedService.offersPreviewTradingSlotByMonths(id, farmerId),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersData = (id, farmerGroupId, data?) => useQuery(
  'milk-fixed-price-offers-data',
  () => MilkFixedService.getOffersData(id, farmerGroupId, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersSettings = (id) => useQuery(
  'milk-fixed-price-offers-settings',
  () => MilkFixedService.offersPreviewTradingSlotOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getTradingActivities = (data?) => useQuery(
  'milk-fixed-price-trading-activities',
  () => MilkFixedService.getTradingActivities(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const getTradingActivityOptions = () => useQuery(
  'milk-fixed-price-activity-options',
  () => MilkFixedService.offersStatusOptions(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerSettingsMilk = () => useQuery(
  'milk-fixed-price-farmer-trading-options',
  () => MilkFixedService.getTradingSlotsFarmerSettings(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const showDataTradingSlot = (id: string) => useQuery(
  'milk-fixed-price-show-trading-slot-data',
  () => MilkFixedService.showTradingSlot(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getPreviewOffersData = (id: string, data?) => useQuery(
  'milk-fixed-price-preview-trading-slot-data',
  () => MilkFixedService.getPreviewOffers(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const farmerOfferAmountsSettings = (id: string) => useQuery(
  'milk-fixed-price-farmer-offer-settings',
  () => MilkFixedService.farmerOfferAmountsSettings(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const MilkFixedPriceQuery = {
  getMilkFixexPriceList,
  getMilkFixexPriceListOptions,
  getMilkFixexPriceOptions,
  getMilkFixexPriceCount,
  getMilkFixexPriceOffers,
  getMilkFixexPriceOffersByOptions,
  getMilkFixexPriceOffersSettings,
  getTradingActivities,
  getTradingActivityOptions,
  getFarmerSettingsMilk,
  getMilkFixexPriceOffersData,
  showDataTradingSlot,
  getPreviewOffersData,
  farmerOfferAmountsSettings
}

